import { useQuery } from 'react-query';

import Api from '../../api/api';

export type ReportedPostsDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
};

const reportedPosts = async (params: ReportedPostsDto) => {
  const [response, bodyOrError] = await Api.get(`posts/reported`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetAllReportedPosts = (params: ReportedPostsDto) => {
  return useQuery({
    queryKey: ['reportedPosts', params],
    queryFn: () => reportedPosts(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};

export default useGetAllReportedPosts;
